<template>
  <px-lateral-dialog persistent v-model="dialog" width="600">
    <template v-slot:activator="{ on }">
      <v-btn color="primary"
             class="mr-3 rounded-tag-small normal-btn-text elevation-0"
             v-on="on">
        Aprovar
      </v-btn>
    </template>
    <template v-slot:title>
      Aprovar compra
    </template>
    <template>
      <v-row dense>
        <v-col cols="23">
          <v-checkbox
            v-model="isChecked"
            label="Confirmar o recebimento e acesso deste pedido de compra pelo fornecedor.">
            <template v-slot:label>
              <span class="body-1">
                Confirmo o recebimento e acesso deste pedido de compra pelo fornecedor.
              </span>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="required"
            label="Mensagem do fornecedor"
            counter="1500"
            rows="1"
            v-model="compra.mensagemFornecedor"
            :error="$v.compra.mensagemFornecedor.$error"
            @blur="$v.compra.mensagemFornecedor.$touch()"
          />
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small"
             :loading="loading"
             :disabled="!isChecked"
             @click="confirm">
        Confirmar
      </v-btn>
      <v-btn color="error"
             class="normal-btn-text rounded-tag-small"
             @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import CompraService from './compra-service';

export default {
  props: {
    compraId: {
      type: Number,
      required: true,
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      isChecked: false,
      comentario: null,
      compra: {
        mensagemFornecedor: null,
      },
    };
  },
  methods: {
    buildPayload() {
      return {
        id: this.compraId,
        mensagemFornecedor: this.compra.mensagemFornecedor,
      };
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      if (this.validateForm()) {
        return;
      }
      this.loading = true;
      CompraService.aprovarComprador(this.compraId, this.buildPayload())
        .then(() => {
          this.$emit('movimentar');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  validations: {
    compra: {
      mensagemFornecedor: {
        required,
      },
    },
  },
};
</script>
